import { SxProps } from '@mui/material'
import { FONT_FAMILY, FONT_WEIGHTS } from '@/styles'
import { bannerClasses } from '../Banner.data'

interface BannerHeadingStyles {
  heading: SxProps
  headingFanatics: SxProps
  animatedHeading: SxProps
}

export const bannerHeadingStyles: BannerHeadingStyles = {
  heading: {
    typography: {
      xs: 'displayMd',
      md: 'displayLg',
      lg: 'displayXl',
    },
    color: 'pageTheme.textColor',
    letterSpacing: {
      xs: '-0.72px',
      lg: '-1.2px',
    },

    [`.${bannerClasses.compact} &`]: {
      typography: {
        xs: 'displayMd',
        lg: 'displayLg',
      },
      fontWeight: {
        xs: FONT_WEIGHTS.MEDIUM,
      },
      letterSpacing: {
        xs: '-0.72px',
        lg: '-1.2px',
      },
    },
    [`.${bannerClasses.fullSize} &`]: {
      color: 'text.primaryWarmIvory',
      typography: {
        xs: 'displaySemiLgMedium',
        md: 'displayXlMedium',
        lg: 'display5xlMedium',
      },
      fontFamily: FONT_FAMILY.SECONDARY,
    },

    [`.${bannerClasses.smokyBlack} &`]: {
      color: 'text.primaryWarmIvory',
    },
  },
  headingFanatics: {
    [`.${bannerClasses.fullSize} &`]: {
      typography: {
        xs: 'displaySmMedium',
        md: 'displayXlMedium',
        lg: 'display4xlMedium',
      },
    },
  },
  animatedHeading: {
    '@keyframes bannerSlideUp': {
      from: { opacity: 0, transform: 'translateY(24px)' },
      to: { opacity: 1, transform: 'translateY(0)' },
    },
    animation: 'bannerSlideUp 0.6s ease both',
  },
}
